import { createSelector } from "@reduxjs/toolkit";
import { useSelector } from "react-redux";

import { getNodeSlotIdSelector, getParentContextByIdSelector } from "../state/index.ts";
import { resolveActiveNodesSelector } from "./querySelectors/index.ts";

const resolveActiveVariablesGroupedByParentContextTitleSelector = createSelector(
  [getNodeSlotIdSelector, resolveActiveNodesSelector, getParentContextByIdSelector],
  (getNodeSlotId, resolveActiveNodes, getParentContextById) =>
    (nodeId: number): Record<number, string> => {
      const variableNodes = resolveActiveNodes(nodeId).filter(
        ({ role }) => role === "variable" || role === "reference-variable",
      );

      return Object.fromEntries(
        variableNodes
          .map((node) => {
            const slotId = getNodeSlotId(node.id);

            if (slotId === undefined) return [undefined, undefined];

            const { parentId } = slotId;
            const parentContext = getParentContextById(parentId);

            if (parentContext === undefined) return [undefined, undefined];

            return [node.id, parentContext.title as string];
          })
          .filter(([key, value]) => key !== undefined && value !== undefined) as [number, string][],
      );
    },
);

export const useActiveVariablesGroupedByParentContextTitle = () =>
  useSelector(resolveActiveVariablesGroupedByParentContextTitleSelector);
